const FACEBOOK = 'facebook'
const TWITTER = 'twitter'
const INSTAGRAM = 'instagram'
const REDDIT = 'reddit'
const GOOGLE = 'google'
const BING = 'bing'
const YAHOO = 'yahoo'

export const SOCIAL_PLATFORMS = {
  FACEBOOK,
  TWITTER,
  INSTAGRAM,
  REDDIT,
}

export const SEARCH_PLATFORMS = {
  GOOGLE,
  BING,
  YAHOO,
}

export const PLATFORM_REGEXS = {
  [FACEBOOK]: [/facebook\.com$/],
  [TWITTER]: [/twitter\.com$/, /^t\.co/],
  [INSTAGRAM]: [/instagram\.com$/],
  [REDDIT]: [/reddit\.com$/],
  [GOOGLE]: [/^google\./, /\.google\./],
  [BING]: [/^bing\./, /\.bing\./],
  [YAHOO]: [/^yahoo\.$/, /\.yahoo\./],
}

export const UNKNOWN_TRAFFIC_SOURCE = 'unknown'
export const UNKNOWN_TRAFFIC_ID = null

export const INFLUENCER_TRAFFIC_SOURCE = 'influencer'
export const APP_TRAFFIC_SOURCE = 'app'
export const EMBED_PARTNER_TRAFFIC_SOURCE = 'embed_partner'
export const SYNDICATION_TRAFFIC_SOURCE = 'syndication'
export const PAID_TRAFFIC_SOURCE = 'paid'
export const SOCIAL_TRAFFIC_SOURCE = 'social'
export const PARTNER_TRAFFIC_SOURCE = 'tr_partner'
export const ORGANIC_TRAFFIC_SOURCE = 'organic'
export const NAVIGATION_TRAFFIC_SOURCE = 'navigation'
export const RSS_TRAFFIC_SOURCE = 'rss'
export const REFERRAL_TRAFFIC_SOURCE = 'referral'
export const DIRECT_TRAFFIC_SOURCE = 'direct'

export const APP_TRAFFIC_ID = null
export const DIRECT_TRAFFIC_ID = null



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/constants.js